import { atom } from 'jotai';

import type { CheckoutTheme } from '@getjust/leaf';

export interface BrandingPreviewData {
  checkoutTheme: CheckoutTheme;
  brandStyles?: {
    brandColorPrimary?: string;
    buttonTextColor?: string;
    background?: 'transparent' | 'white';
  };
  logoUrl?: string;
  backgroundUrl?: string;
}

export const brandingPreviewAtom = atom<BrandingPreviewData | undefined>(undefined);
